export default "__VITE_ASSET__CJF1neIf__"